import request from '@/config/axios'

export const getReservationPage = (params: any) =>
  request.get({ url: '/live/reservation/page', params })
export const deleteReservation = (id: number) =>
  request.delete({ url: '/live/reservation/delete', params: { id } })
